export default __webpack_public_path__ + "static/media/episodes.2e75d55b.svg";